// English translations
export const en: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Dashboard',
  'menu.orderNew': 'New Order',
  'menu.deliveryList': 'Ready for Delivery',
  'menu.delivery': 'Delivery',
  'menu.driverPickup': 'Pickup Orders',
  'menu.receipt': 'Print Receipt',
  'menu.carWash': 'Car Wash',
  'menu.referral': 'Invite',
  'menu.barber': 'Barber / Salon',
  
  // Definitions
  'menu.definitions': 'Definitions',
  'menu.customers': 'Customers',
  'menu.products': 'Product Definitions',
  'menu.pricing': 'Product Price Definitions',
  'menu.tailoring': 'Tailoring',
  'menu.attributes': 'Product Attributes',
  'menu.users': 'Users',
  'menu.productOrdering': 'Product Order Definitions',
  'menu.discounts': 'Discount Definitions',
  
  // Settings
  'menu.settings': 'Settings',
  'menu.generalSettings': 'General Settings',
  'menu.permissions': 'Permission Management',
  'menu.subscription': 'Subscription',
  'menu.payment': 'Payment',
  'menu.invoices': 'Invoice Management',
  'menu.expenses': 'Expenses',
  'menu.zReport': 'Z Report',
  'menu.reportsList': 'Receipt List',
  'menu.reportsCharts': 'Charts Report',
  'menu.reportsAndAccounting': 'Reports & Accounting',
  'reportsList.totalReceipts': 'Total Receipts',
  'reportsList.registered': 'Registered',
  'reportsList.delivered': 'Delivered',
  'reportsList.totalRevenueExclCancelled': 'Total Revenue (Excl. Cancelled)',
  'reportsList.activeOnly': 'Active Orders Only',
  'reportsList.receiptNumber': 'Receipt No',
  'reportsList.customer': 'Customer',
  'reportsList.phone': 'Phone',
  'reportsList.date': 'Date',
  'reportsList.amount': 'Amount',
  'reportsList.status': 'Status',
  'reportsList.payment': 'Payment',
  'reportsList.searchPlaceholder': 'Receipt no, customer name or phone...',
  'reportsList.noOrders': 'No orders found',
  'reportsList.cancelled': 'Cancelled',
  'reportsList.reprint': 'Reprint',
  'menu.systemAndCommunication': 'System & Communication',
  'menu.accountStatement': 'Account Statement',
  'menu.tickets': 'Support Tickets',
  'menu.support': 'Support',
  'menu.profile': 'Profile',
  'menu.logout': 'Logout',
  'menu.notifications': 'SMS/WhatsApp Notifications',
  'menu.whatsappConnection': 'WhatsApp Connection',
  'menu.smsConnection': 'SMS Connection',
  'menu.hardware': 'Hardware',
  
  // Navigation (for compatibility)
  'nav.logout': 'Logout',
  'nav.user': 'User',
  
  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.todaySales': 'Today\'s Sales',
  'dashboard.totalOrders': 'Total Orders',
  'dashboard.pendingDeliveries': 'Pending Deliveries',
  'dashboard.activeCustomers': 'Active Customers',
  'dashboard.recentOrders': 'Recent Orders',
  'dashboard.viewAll': 'View All',
  'dashboard.quickActions': 'Quick Actions',
  'dashboard.newOrder': 'New Order',
  'dashboard.newCustomer': 'New Customer',
  'dashboard.deliveries': 'Deliveries',
  'dashboard.reports': 'Reports',
  'dashboard.today': 'Today',
  'dashboard.yesterday': 'Yesterday',
  'dashboard.week': 'Week',
  'dashboard.month': 'Month',
  'dashboard.quarter': 'Quarter',
  'dashboard.year': 'Year',
  'dashboard.totalRevenue': 'Total Revenue',
  'dashboard.totalPieces': 'Total Pieces',
  'dashboard.cancelled': 'Cancelled',
  'dashboard.inProcess': 'In Process',
  'dashboard.inProcessDesc': 'Orders in process',
  'dashboard.ready': 'Ready',
  'dashboard.readyDesc': 'Ready in selected period',
  'dashboard.delivered': 'Delivered',
  'dashboard.deliveredDesc': 'Delivered in selected period',
  'dashboard.allTime': 'All Time',
  'dashboard.announcements': 'Announcements',
  'dashboard.announcementAll': 'General',
  'dashboard.announcementPrivate': 'Private',
  'dashboard.referral.title': 'Invite Your Friend',
  'dashboard.referral.desc': 'Get 1 extra month when an invited business signs up!',
  'dashboard.referral.button': 'Invite Now',
  
  // Service Types
  'service.tailor': 'Tailor',
  'service.dryCleaning': 'Dry Cleaning',
  'service.washing': 'Washing',
  'service.ironing': 'Ironing',
  'service.dyeing': 'Dyeing',
  'service.shoeShine': 'Shoe Shine',
  'service.carpetWashing': 'Carpet Washing',
  'service.sofaWashing': 'Sofa Washing',
  'service.carWash': 'Car Wash & Detailing',
  'service.barber': 'Barber / Hairdresser',
  'service.carpet': 'Carpet',
  'service.tailoring': 'Tailoring Repair',
  'service.carpetWashing': 'Carpet Washing',
  'service.selectService': 'Select Service',
  'service.addToCart': 'Add to Cart',
  'service.total': 'Total',
  
  // Service Abbreviations (for receipts)
  'service.dryCleaningShort': 'DC',
  'service.ironingShort': 'Iron',
  'service.dyeingShort': 'Dye',
  'service.washingShort': 'Wash',
  'service.tailoringShort': 'Tailor',
  'service.shoeShineShort': 'Shine',
  'service.carpetShort': 'Carpet',
  
  // Order Status
  'status.pending': 'In Process',
  'status.ready': 'Ready',
  'status.delivered': 'Delivered',
  'status.cancelled': 'Cancelled',
  'status.pickup_pending': 'To Pickup',
  'status.pickup_in_progress': 'Picking Up',
  'status.received': 'Received',
  
  // Order Create Page
  'orderCreate.cart': 'Cart',
  'orderCreate.totalPieces': 'Total Pieces',
  'orderCreate.plannedDelivery': 'Planned Delivery',
  'orderCreate.payment': 'Payment',
  'orderCreate.save': 'Save',
  'orderCreate.continue': 'Continue',
  'orderCreate.allCategories': 'All',
  
  // Area Calculation Dialog
  'areaCalculation.title': 'Area Calculation',
  'areaCalculation.carpetCount': '🔢 Carpet Count',
  'areaCalculation.carpetCountPlaceholder': 'How many carpets?',
  'areaCalculation.directInput': '📏 Enter m² Directly',
  'areaCalculation.totalSqM': '📏 Total m² (for {count} carpets)',
  'areaCalculation.exampleSqM': 'Ex: 12.5',
  'areaCalculation.or': 'OR',
  'areaCalculation.width': 'Width (m)',
  'areaCalculation.height': 'Height (m)',
  'areaCalculation.exampleNumber': 'Ex: 4',
  'areaCalculation.calculatedArea': 'Calculated Area:',
  'areaCalculation.perCarpet': 'Per carpet',
  'areaCalculation.total': 'Total',
  'areaCalculation.continue': 'Continue',
  'orderCreate.selectCustomer': 'Select Customer',
  'orderCreate.selectCustomerPlaceholder': 'Select customer',
  'orderCreate.change': 'Change',
  'orderCreate.select': 'Select',
  'orderCreate.balance': 'Balance',
  'orderCreate.searchCustomer': 'Search by name, phone, or address... (example: john+5551234567)',
  'orderCreate.newCustomer': 'New Customer',
  'orderCreate.customerName': 'Name Surname',
  'orderCreate.customerPhone': 'Phone',
  'orderCreate.customerEmail': 'Email',
  'orderCreate.customerAddress': 'Address',
  'orderCreate.addCustomer': 'Add Customer',
  
  // Placeholders - Customer Form
  'placeholder.customerName': 'e.g. JOHN SMITH',
  'placeholder.customerPhone': 'e.g. 555 123 4567',
  'placeholder.customerEmail': 'e.g. john@example.com',
  'placeholder.customerAddress': 'e.g. MANHATTAN, NEW YORK',
  'placeholder.customerNotes': 'e.g. VIP CUSTOMER',
  
  'orderCreate.customer': 'Customer',
  'orderCreate.serviceType': 'Service Type',
  'orderCreate.clickToSelect': 'Click to select',
  'orderCreate.deliveryDate': 'Delivery Date',
  'orderCreate.details': 'Details',
  'orderCreate.itemDetails': 'Item Details',
  'orderCreate.tailoringOperations': 'Tailoring Operations',
  'orderCreate.tailoringTitle': 'Tailoring Operations',
  'orderCreate.selectOperation': 'Select operation (prices will be added automatically)',
  'orderCreate.selectedOperations': 'Selected Operations',
  'orderCreate.discount': 'Discount',
  'orderCreate.discountLabel': 'Discount (%)',
  'orderCreate.debt': 'Debt',
  'orderCreate.credit': 'Credit',
  'orderCreate.homeDelivery': 'Home Delivery',
  'order.homeDelivery': 'Home Delivery',
  'orderCreate.homeDeliveryAddress': 'Address',
  'orderCreate.addressRequired': 'Address required!',
  'orderCreate.pickupFromAddress': 'Driver will pick up',
  'orderCreate.subtotal': 'Subtotal',
  'orderCreate.grandTotal': 'Grand Total',
  
  // Products
  'products.title': 'Product Definitions',
  'products.addNew': 'New Product',
  'products.category': 'Category',
  'products.name': 'Product Name',
  'products.price': 'Price',
  'products.color': 'Color',
  'products.active': 'Active',
  'products.actions': 'Actions',
  'products.search': 'Search Product...',
  'products.noProducts': 'No products found',
  'products.noCategoryProducts': 'No products found in this category',
  'products.emptyCart': 'Cart is empty',
  
  // Customers
  'customers.title': 'Customers',
  'customers.addNew': 'New Customer',
  'customers.search': 'Search Customers...',
  'customers.name': 'Name',
  'customers.phone': 'Phone',
  'customers.email': 'Email',
  'customers.address': 'Address',
  'customers.balance': 'Balance',
  'customers.actions': 'Actions',
  'customers.edit': 'Edit',
  'customers.delete': 'Delete',
  'customers.noCustomers': 'No customers found',
  'customers.tableCustomer': 'Customer',
  'customers.tableContact': 'Contact',
  'customers.tableAddress': 'Address',
  'customers.tableNotifications': 'Notifications',
  'customers.tableBalance': 'Balance',
  'customers.tableActions': 'Actions',
  'customers.totalCount': 'Total {count} customers',
  'customers.notes': 'Note',
  'customers.whatsappEnabled': 'WhatsApp',
  'customers.smsEnabled': 'SMS',
  'customers.searchPlaceholder': 'Search by name, phone, email or address... (example: john+5551234567)',
  'customers.updated': 'Customer updated',
  'customers.updateError': 'Failed to update customer',
  'customers.added': 'Customer added',
  'customers.addError': 'Failed to add customer',
  'customers.deleted': 'Customer deleted',
  'customers.deleteError': 'Failed to delete customer',
  'customers.deleteConfirm': 'Are you sure you want to delete customer "{name}"?',
  'customers.loadError': 'Failed to load customers',
  'customers.noResults': 'No results found',
  'customers.showingFirst50': 'Showing first 50 results',
  'customers.totalResults': 'total',
  'customers.import': 'Import Customers',
  'customers.importTitle': 'Import Customers',
  'customers.telefon': 'Phone',
  'customers.telefon2': 'Phone 2',
  'customers.adres': 'Address',
  'customers.notFound': 'No customer found',
  'customers.legacyHidden': 'legacy format customers hidden',
  'customers.cannotDeleteWithOrders': 'Cannot delete customer with existing orders',
  'customers.phoneMissing': 'Customer phone number not registered',
  
  // Users
  'users.title': 'Users',
  'users.addNew': 'New User',
  'users.name': 'Full Name',
  'users.email': 'Email',
  'users.role': 'Role',
  'users.pin': 'PIN',
  'users.permissions': 'Permissions',
  'users.allPermissions': 'All Permissions',
  'users.permissionCount': '{count} permissions',
  'users.changePin': 'Change PIN',
  'users.edit': 'Edit',
  'users.newUser': 'New User',
  'users.editUser': 'Edit User',
  'users.editingUser': 'Editing user {name}',
  'users.pinCode': 'PIN Code (4-6 digits)',
  'users.selectRole': 'Select role',
  'users.patron': 'Owner',
  'users.kasiyer': 'Cashier',
  'users.sofor': 'Driver',
  'users.eleman': 'Staff',
  'users.changePinTitle': 'Change PIN Code',
  'users.newPin': 'New PIN Code',
  'users.confirmPin': 'Confirm PIN Code',
  'users.pinMismatch': 'PIN codes do not match',
  'users.pinRequired': 'PIN code is required',
  'users.pinLength': 'PIN code must be 4-6 digits',
  'users.changingPinFor': 'Changing PIN code for {name}',
  
  // Pricing Page
  'pricing.title': 'Price Definitions',
  'pricing.search': 'Search Product...',
  'pricing.product': 'Product',
  'pricing.dryCleaning': 'Dry Cleaning',
  'pricing.washing': 'Washing',
  'pricing.ironing': 'Ironing',
  'pricing.dyeing': 'Dyeing',
  'pricing.tailoring': 'Tailoring Repair',
  'pricing.shoeShine': 'Shoe Shine',
  'pricing.action': 'Action',
  'pricing.save': 'Save',
  'pricing.enterPrice': 'Enter price',
  'pricing.percent': 'Percent',
  'pricing.amount': 'Amount',
  'pricing.saving': 'Saving',
  'pricing.pricesSaved': 'Prices saved',
  'pricing.pricesSaveError': 'Failed to save prices',
  'pricing.noProducts': 'No products found',
  'pricing.loadError': 'Failed to load products',
  
  // Tailoring Page
'tailoring.title': 'Tailoring Options',
  'tailoring.addNew': 'New Operation',
  'tailoring.pacaBoyu': 'Armhole adjustment',
  'tailoring.belAyarı': 'Waist adjustment',
  'tailoring.kolBoyu': 'Sleeve length',
  'tailoring.fermuarDegisimi': 'Zipper replacement',
  'tailoring.dugmeDikme': 'Button sewing',
  'tailoring.sokukDikimi': 'Seam repair',
  'tailoring.yama': 'Patch',
  'tailoring.astarDegisimi': 'Lining replacement',
  'tailoring.omuzAyarı': 'Shoulder adjustment',
  'tailoring.cepDikimi': 'Pocket sewing',
  'tailoring.addCustom': 'Add Custom Operation',
  'tailoring.operationName': 'Operation Name',
  'tailoring.price': 'Price',
  'tailoring.icon': 'Icon',
  'tailoring.save': 'Save',
  'tailoring.cancel': 'Cancel',

  // Delivery List
  'deliveryList.title': 'Delivery List',
  'deliveryList.all': 'All',
  'deliveryList.pending': 'Pending',
  'deliveryList.ready': 'Ready',
  'deliveryList.delivered': 'Delivered',
  'deliveryList.items': 'Items',
  'deliveryList.whatsappSent': 'WhatsApp message sent!',
  'deliveryList.whatsappError': 'WhatsApp message could not be sent',
  'deliveryList.messageError': 'Customer message could not be sent',
  'deliveryList.orderDelivered': 'Order marked as delivered',
  'deliveryList.orderCancelled': 'Order cancelled',
  'deliveryList.deliveryError': 'Error marking as delivered',
  'deliveryList.cancelTitle': 'Cancel Receipt',
  'deliveryList.cancelConfirm': 'Are you sure you want to cancel this order? Cancel reason is required.',
  'deliveryList.cancelReasonPlaceholder': 'Cancel reason (required)...',
  'deliveryList.cancelButton': 'Cancel Order',

  // Delivery Page
  'deliveryPage.title': 'Delivery',
  'deliveryPage.searchBy': 'Search by',
  'deliveryPage.searchAll': 'All',
  'deliveryPage.searchReceipt': 'Receipt No',
  'deliveryPage.searchName': 'Customer Name',
  'deliveryPage.searchPhoneBtn': 'Phone',
  'deliveryPage.searchReceiptPlaceholder': 'Search by receipt no...',
  'deliveryPage.searchNamePlaceholder': 'Enter receipt no or customer name...',
  'deliveryPage.search': 'Search',
  'deliveryPage.searchPhone': 'Search by phone...',
  'deliveryPage.searchEmptyTitle': 'Search by receipt no, name or phone',
  'deliveryPage.searchEmptySubtitle': 'Orders ready for delivery will be listed',
  'deliveryPage.statusPending': 'Pending',
  'deliveryPage.pieces': 'Pieces',
  'deliveryPage.amount': 'Amount',
  'deliveryPage.payment': 'Payment',
  'deliveryPage.showItems': 'Show Items',
  'deliveryPage.itemsList': 'Items List',
  'deliveryPage.deliverButton': 'Deliver Selected',
  'deliveryPage.unknownProduct': 'Unknown Product',
  'deliveryPage.noOrdersFound': 'No orders found',
  'deliveryPage.noReadyOrders': 'No ready orders',
  'deliveryPage.minSearchLength': 'Please enter at least 2 characters',
  'deliveryPage.paymentDialogTitle': 'Select Payment Method',
  'deliveryPage.ordersLoadError': 'Failed to load orders',
  'deliveryPage.deliverySuccess': 'Delivery successful',
  'deliveryPage.deliveryError': 'Delivery error',
  'deliveryPage.searchPlaceholder': 'Search...',
  'deliveryPage.changeToPickup': 'Pickup',
  'deliveryPage.changeToPickupSuccess': 'Delivery type changed to "Pickup"',
  'deliveryPage.changeToPickupError': 'Failed to change delivery type',
  'deliveryPage.changeToDelivery': 'Home Delivery',
  'deliveryPage.changeToDeliverySuccess': 'Delivery type changed to "Home Delivery"',
  'deliveryPage.changeDeliveryType': 'Change Delivery Type',

  // Delivery
  'delivery.deliveredItems': 'Delivered',
  'delivery.deliveredProducts': 'DELIVERED PRODUCTS',
  'delivery.error': 'Delivery error',
  'delivery.markReady': 'Mark Ready',
  
  // Users
  'users.delete': 'Delete',
  'users.deleteUserTitle': 'Delete User',
  'users.deletingUser': 'Are you sure you want to delete user {name}?',
  'users.deleteError': 'Failed to delete user',
  'users.loadError': 'Failed to load users',
  'users.userDeleted': 'User deleted successfully',
  'users.userDeleteError': 'Failed to delete user',
  
  // Products
  'products.newProduct': 'New Product',
  'products.editProduct': 'Edit Product',
  'products.productName': 'Product Name',
  'products.productPrice': 'Price',
  'products.productCategory': 'Category',
  'products.productActive': 'Active',
  'products.productInActive': 'Inactive',
  'products.pieceCount': 'Piece Count',
  'products.updatePrice': 'Update Price',
  'products.updatePrices': 'Update Prices',
  'products.allCategories': 'All Categories',
  'products.searchProduct': 'Search Product...',
  'products.save': 'Save',
  'products.saving': 'Saving...',
  'products.saved': 'Saved',
  'products.saveError': 'Failed to save',
  'products.deleteConfirm': 'Are you sure you want to delete this product?',
  'products.delete': 'Delete',
  'products.deleting': 'Deleting...',
  'products.loadError': 'Failed to load products',
  'products.addError': 'Failed to add product',
  'products.updateError': 'Failed to update product',
  'products.deleteError': 'Failed to delete product',
  'products.productAdded': 'Product added',
  'products.productUpdated': 'Product updated',
  'products.productDeleted': 'Product deleted',
  
  // Attributes
  'attributes.addColor': 'Add Color',
  'attributes.addStain': 'Add Stain Type',
  'attributes.addDamage': 'Add Damage Type',
  'attributes.save': 'Save',
  'attributes.saved': 'Saved',
  'attributes.saveError': 'Failed to save',
  'attributes.loadError': 'Failed to load attributes',
  'attributes.addError': 'Failed to add',
  'attributes.updateError': 'Failed to update',
  'attributes.deleteError': 'Failed to delete',
  
  // Delivery
  'delivery.searchOrder': 'Search by order number or customer name...',
  'delivery.loadError': 'Failed to load deliveries',
  'delivery.updateError': 'Failed to update status',
  'delivery.orderReady': 'Order marked as ready',
  'delivery.orderDelivered': 'Order marked as delivered',
  'delivery.noOrders': 'No orders found',
  
  // Notifications
  'notifications.send': 'Send',
  'notifications.sending': 'Sending...',
  'notifications.sent': 'Sent',
  'notifications.sendError': 'Failed to send',
  'notifications.selectCustomer': 'Select Customer',
  'notifications.selectTemplate': 'Select Template',
  'notifications.customMessage': 'Custom Message',
  'notifications.message': 'Message',
  'notifications.preview': 'Preview',
  'notifications.whatsapp': 'WhatsApp',
  'notifications.sms': 'SMS',
  'notifications.sendNow': 'Send Now',
  'notifications.schedule': 'Schedule',
  'notifications.scheduleLater': 'Send Later',
  'notifications.selectDateTime': 'Select Date & Time',
  'notifications.success': 'Notification sent successfully',
  'notifications.failure': 'Failed to send notification',
  
  // Profile
  'profile.title': 'Profile',
  'profile.name': 'Name',
  'profile.email': 'Email',
  'profile.phone': 'Phone',
  'profile.role': 'Role',
  'profile.save': 'Save',
  'profile.saving': 'Saving...',
  'profile.saved': 'Saved',
  'profile.saveError': 'Failed to save profile',
  'profile.changePassword': 'Change Password',
  'profile.currentPassword': 'Current Password',
  'profile.newPassword': 'New Password',
  'profile.confirmPassword': 'Confirm Password',
  'profile.passwordMismatch': 'Passwords do not match',
  'profile.passwordChanged': 'Password changed successfully',
  'profile.passwordChangeError': 'Failed to change password',
  
  // Settings
'settings.showTax': 'Show Tax',
  'settings.headerInfo': 'Header Info',
  'settings.headerInfoPlaceholder': 'e.g: Dry Cleaning & Ironing',
  'settings.phonePlaceholder': 'e.g: 0212 123 45 67',
  'settings.footerTextHelp': 'Short message to appear at bottom of receipt',
  'settings.receiptNoteHelp': 'Detailed terms and conditions',
  'settings.receiptPreview': 'Receipt Preview',
  'settings.languageRegion': 'Language & Region',
  'settings.language': 'Language',
  'settings.currency': 'Currency',
  'settings.currencyPosition': 'Currency Position',
  'settings.currencyPositionLeft': 'Left (₺100)',
  'settings.currencyPositionRight': 'Right (100₺)',
  'settings.numberFormat': 'Number Format',
  'settings.numberFormatDotComma': 'Dot for decimals (1.234,56)',
  'settings.numberFormatCommaDot': 'Comma for decimals (1,234.56)',
  'settings.numberFormatSpaceComma': 'Space for decimals (1 234,56)',
  'settings.showDecimals': 'Show Decimal Places',
  'settings.showDecimalsDesc': 'Display 2 decimal places for amounts',
  'settings.dateFormat': 'Date Format',
  'settings.timezone': 'Timezone',
  'settings.taxRate': 'Tax Rate',
  'settings.receiptSettings': 'Receipt Settings',
  'settings.logo': 'Logo',
  'settings.removeLogo': 'Remove Logo',
  'settings.uploadLogo': 'Upload Logo',
  'settings.companyName': 'Company Name',
  'settings.companyNamePlaceholder': 'Enter company name',
  'settings.phone': 'Phone',
  'settings.address': 'Address',
  'settings.addressPlaceholder': 'Enter address',
  'settings.footerText': 'Footer Text',
  'settings.footerTextPlaceholder': 'Enter footer text',
  'settings.receiptNote': 'Receipt Note',
  'settings.receiptNotePlaceholder': 'Enter receipt note',
  'settings.socialMedia': 'Social Media',
  'settings.website': 'Website',
  'settings.turkey': 'Turkey',
  'settings.europe': 'Europe',
  'settings.middleEast': 'Middle East',
  'settings.americas': 'Americas',
  'settings.asia': 'Asia',
  'settings.oceania': 'Oceania',
  'settings.africa': 'Africa',
  'settings.asiaPacific': 'Asia Pacific',
  'settings.popularLanguages': 'Popular Languages',
  'settings.europeanLanguages': 'European Languages',
  'settings.asianLanguages': 'Asian Languages',
  'settings.middleEastAfricanLanguages': 'Middle East & African Languages',
  'settings.otherLanguages': 'Other Languages',
  'settings.majorCurrencies': 'Major Currencies',
  'settings.middleEastGulf': 'Middle East & Gulf',
  'settings.formerSovietTurkic': 'Former Soviet & Turkic',
  'settings.genericEscPos': 'Generic ESC/POS',
  'settings.productsWillBeKept': 'Products will be kept',
  'settings.dangerZone': 'Danger Zone',
  'settings.deleteDemoDataWarning': 'Removes the sample customers added automatically at setup, together with their receipts and payments. Customers and receipts you added yourself are not deleted.',
  'settings.deleteDemoData': 'Delete Demo Data',
  'settings.deleteDemoDataTitle': 'Delete Demo Data',
  'settings.deleteDemoDataConfirm': 'This cannot be undone! The sample customers and their receipts/payments will be deleted; your own customers and receipts will be kept.',
  'toast.noDemoData': 'No sample customers found to delete.',
  'toast.demoCustomersKept': '{n} sample customer(s) kept because they have receipts you created; only their sample receipts were deleted.',
  'settings.areYouSure': 'Are you sure?',
  'settings.deleting': 'Deleting...',
  'settings.loadSchema': 'Load Schema',
  'settings.loadSchemaTitle': 'Load Database Schema',
  'settings.loadSchemaConfirm': 'This will create the database schema. Continue?',
  'settings.connected': 'Connected',
  'settings.notConnected': 'Not Connected',
  'settings.connect': 'Connect',
  'settings.disconnect': 'Disconnect',
  
  // Settings - New translations
  'settings.labelPrinter': 'Label Printer',
  'settings.printerSettings': 'Printer Settings',
  'settings.webSerialSupported': 'Web Serial API Supported',
  'settings.browserNotSupported': 'Browser Not Supported',
  'settings.printerModel': 'Printer Model',
  'settings.paperWidth': 'Paper Width',
  'settings.autoConnect': 'Auto-connect on startup',
  'settings.feedForward': 'Feed Forward',
  'settings.reverse': 'Reverse',
  'settings.cut': 'Cut',
  'settings.openDrawer': 'Open Drawer',
  'settings.testPrint': 'Test Print',
  'settings.testPrinted': 'Test printed!',
  'settings.webSerialNotSupported': 'Web Serial API is not supported by your browser. We recommend using Chromium-based browsers (Chrome, Edge, Brave).',
  'settings.callerId': 'Caller ID',
  'settings.lastCall': 'Last call',
  'settings.howToConnect': '💡 How to Connect?',
  'settings.connectDeviceInfo': 'Connect the USB Caller ID device to your computer',
  'settings.clickConnectButton': 'Click the "Connect" button',
  'settings.selectDevice': 'Select the CID device from the list (usually "USB Serial Device")',
  'settings.testPrintHeader': '=== TEST PRINTER ===',
  'settings.printerConnection': 'Printer connection',
  'settings.successful': 'successful!',
  'settings.reverseTest': '--- Reverse payment test ---',
  'settings.receiptVisibleOnReceipt': 'Shown on Receipt',
  'settings.company': 'Company',
  'settings.email': 'Email',
  'settings.saved': 'Settings saved!',
  'settings.saveError': 'Failed to save settings',
  'settings.general': 'General',
  'settings.notifications': 'Notifications',
  'settings.integrations': 'Integrations',
  'settings.printer': 'Printer',
  'settings.printerConnected': 'Connected',
  'settings.printerNotConnected': 'Not Connected',
  'settings.printerConnect': 'Connect',
  'settings.printerDisconnect': 'Disconnect',
  'settings.title': 'Settings',
  'settings.save': 'Save',
  
  // Signup
  'signup.companyDetails': 'Company Details',
  'signup.subtitle': 'Start your 15-day free trial',
  'signup.fields.companyCode': 'Company Code',
  'signup.placeholders.companyCode': 'e.g: cleanpro',
  'signup.hints.companyCode': 'This code will be used to log in. It can only contain letters and numbers.',
  'signup.fields.companyName': 'Company Name',
  'signup.placeholders.companyName': 'e.g: CleanPro Dry Cleaning',
  'signup.fields.ownerName': 'Full Name',
  'signup.placeholders.ownerName': 'e.g: John Doe',
  'signup.fields.email': 'Email Address',
  'signup.placeholders.email': 'e.g: john@cleanpro.com',
  'signup.fields.phone': 'Phone Number',
  'signup.placeholders.phone': 'e.g: +1 123 456 7890',
  'signup.fields.country': 'Country',
  'signup.hints.country': 'Currency and language settings will be automatically configured based on your country.',
  'signup.freeTrial': '🎁 15 days free trial included!',
  'signup.businessType.question': 'What type of business do you have?',
  'signup.businessType.hint': 'Your default screen will be set automatically based on your selection',
  'signup.businessType.continue': 'Continue',
  'signup.bt.dryCleaning.desc': 'Clothing, curtain & textile cleaning',
  'signup.bt.carpetWashing.desc': 'Carpet, rug & runner cleaning',
  'signup.bt.shoeShine.desc': 'Shoe cleaning & care',
  'signup.bt.sofaWashing.desc': 'Sofa, couch & armchair cleaning',
  'signup.bt.carWash.desc': 'Car washing, waxing, polishing & detailing',
  'signup.bt.tailoring.desc': 'Tailoring, alterations & sewing services',
  'signup.bt.barber.desc': 'Hairdresser, barber & beauty salon',
  'signup.createAccount': 'Create Account',
  'signup.haveAccount': 'Already have an account? Log in',
  'signup.creating': 'Creating account...',
  'signup.success': 'Your account has been successfully created!',
  'signup.errors.companyCodeRequired': 'Company code is required',
  'signup.errors.companyCodeTooShort': 'Company code must be at least 3 characters',
  'signup.errors.companyNameRequired': 'Company name is required',
  'signup.errors.ownerNameRequired': 'Full name is required',
  'signup.errors.emailRequired': 'Email address is required',
  'signup.errors.emailInvalid': 'Please enter a valid email address',
  'signup.errors.signupFailed': 'Signup failed',

  // Common
  'common.autoDetected': 'Auto-detected',

  // Footer
  'footer.euServers': 'Your data is securely stored on our European Union (Frankfurt) servers.',
  'footer.gdpr': 'GDPR compliant infrastructure.',

  // Toasts
  'toast.demoDataDeleted': 'Demo data deleted',
  'toast.demoDataDeleteError': 'Failed to delete demo data',
  'toast.orderCreated': 'Order created',
  'toast.orderError': 'Failed to create order',
  'toast.customerAdded': 'Customer added',
  'toast.customerError': 'Failed to add customer',
  'toast.productError': 'Failed to add product',
  'toast.qrGenerated': 'QR code generated. Please scan with your WhatsApp Business app.',
  'toast.qrError': 'Failed to generate QR code',
  'toast.whatsappConnected': 'WhatsApp Business connected successfully!',
  'toast.whatsappDisconnected': 'WhatsApp Business disconnected',
  'toast.connectionError': 'Failed to save connection',
  'toast.disconnectError': 'Failed to disconnect',
  'toast.connectionStatusError': 'Failed to load connection status',
  'toast.statsError': 'Failed to load statistics',
  'toast.userAdded': 'User added',
  'toast.userAddError': 'Failed to add user',
  'toast.userUpdated': 'User updated',
  'toast.userUpdateError': 'Failed to update user',
  'toast.usersLoadError': 'Failed to load users',
  'toast.pinChanged': 'PIN code changed',
  'toast.pinChangeError': 'Failed to change PIN code',
  'toast.userDeleted': 'User deleted successfully',
   'toast.userDeleteError': 'Failed to delete user',
   'toast.orderDetailsLoadError': 'Order details could not be loaded',
   'toast.orderLoadError': 'Order could not be loaded',
   'toast.deliveryDatePastError': 'Delivery date cannot be earlier than today',
   'toast.fillAllCardInfo': 'Please fill in all card information',
   'toast.invalidCardNumber': 'Invalid card number',
   'toast.invalidMonth': 'Invalid month (must be 1-12)',
   'toast.invalidYear': 'Invalid year',
   'toast.invalidCvc': 'Invalid CVC',
   'toast.addressRequiredForDelivery': 'Customer address is required for home delivery/pickup. Please fill in the address information.',
   'toast.cardPaymentSuccessMsg': 'Card payment successful!',
   'toast.cardPaymentFailed': 'Payment failed. Please try again.',
   'toast.paymentStatusCheckError': 'Payment status could not be checked. Please check your account.',
   'toast.paymentStatusCheckErrorShort': 'Payment status could not be checked.',
   'toast.selectCustomer': 'Please select a customer',
   'toast.addProduct': 'Please add a product',
   'toast.productAddedSimple': 'Product added',
   'toast.editCancelled': 'Edit cancelled',
   'toast.searchError': 'Search error',
   'toast.customerDebt': 'Customer debt: {amount}',
   'toast.customerOpenOrders': 'Customer has {count} open orders',
   'toast.productAddedToCart': 'Product added to cart',
   
   // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Business Management System',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'login.tenantId': 'Company Code',
  'login.tenantPlaceholder': 'e.g: cleanpro',
  'login.continue': 'Continue',
  'login.login': 'Sign In',
  'login.loggingIn': 'Signing in...',
  'login.welcome': 'Welcome, {name}',
  'login.loginFailed': 'Login failed',
  'login.pinMinLength': 'PIN must be at least 4 digits',
  'login.invalidTenantId': 'Please enter a valid company code',
  'login.notMember': 'Not a member yet?',
  'login.startTrial': 'Start Free Trial',
  'login.changeTenant': 'Change Company',
  'login.clear': 'Clear',
  'login.systemInitializing': 'System initializing...',
  'login.usernameRequired': 'Username is required',
  'login.tenantNotFound': 'Company not found: "{tenantId}"',
  'login.credentialsTitle': 'Login Credentials',
  'login.saveCredentialsNote': 'Please save these credentials!',
  'login.demoLoaded': 'Demo users, products, customers and orders created!',
  'login.pinRequired': 'PIN is required',
  'login.invalidCredentials': 'Invalid username or PIN',
  'login.rememberMe': 'Remember me',
  'login.tenantRequired': 'Company ID is required',
  'login.tenantIdNotRemembered': 'Company ID not remembered',
  'login.username': 'Username',
  'login.forget': 'Forget',
  'login.enterCredentials': 'Enter username and PIN',
  'login.usernamePlaceholder': 'owner, cashier...',
  'login.pin': 'PIN',
  'login.signIn': 'Sign In',
  'login.signingIn': 'Signing in...',
  'login.tryForFree': 'Try for free for 15 days, no credit card required',
  'login.pinDescription': '4-6 digits',
  'login.firstLoginChangePin': 'First login - Please change your PIN code',
  'login.legalText': 'By creating an account you agree to our Terms of Service and Privacy Policy',
  'login.demoAccount': 'Demo Account',
  'login.demoCredentials': 'Username: demo, PIN: 1234',
  'login.version': 'Version',
  
  // Common

  // Additional missing translations
  'errorBoundary.unauthorized': 'Unauthorized',
  'errorBoundary.unauthorizedDetails': 'You are not authorized to perform this action.',
  'errorBoundary.unknownError': 'Unknown Error',
  'login': 'Login',
  'logout': 'Logout',
  'notifications': 'Notifications',
  'order.addProduct': 'Add Product',
  'order.customer': 'Customer',
  'order.discount': 'Discount',
  'order.grandTotal': 'Grand Total',
  'order.newCustomer': 'New Customer',
  'order.price': 'Price',
  'order.products': 'Products',
  'order.quantity': 'Quantity',
  'order.selectCustomer': 'Select Customer',
  'order.selectProduct': 'Select Product',
  'order.subtotal': 'Subtotal',
  'order.tax': 'Tax',
  'order.title': 'New Order',
  'order.total': 'Total',
  'settings.expenses': 'Expenses',
  'settings.invoices': 'Invoices',
  'settings.menu': 'Settings Menu',
  'settings.reports': 'Reports',
  'settings.tickets': 'Support Tickets',
  'settings.zReport': 'Z Report',
  'reports.salesReport': 'Sales Report',
  'reports.dateRange': 'Date Range',
  'reports.totalSales': 'Total Sales',
  'reports.ordersCount': 'Orders Count',
  'reports.averageOrder': 'Average Order',
  'zreport.title': 'Z Report',
  'zreport.date': 'Date',
  'zreport.cash': 'Cash',
  'zreport.card': 'Card',
  'zreport.total': 'Total',
  'zreport.orders': 'Orders',
  'zreport.print': 'Print',
  'subscription.currentPlan': 'Current Plan',
  'subscription.upgrade': 'Upgrade',
  'subscription.downgrade': 'Downgrade',
  'subscription.cancel': 'Cancel',
  'subscription.features': 'Features',
  'subscription.monthly': 'Monthly',
  'subscription.yearly': 'Yearly',
  'subscription.popular': 'Popular',
  'subscription.buyNow': 'Buy Now',
  'subscription.contactSales': 'Contact Sales',
  'subscription.trialEnd': 'Trial ends',
  'subscription.daysLeft': 'days left',
  'announcement.welcome': 'Welcome to Cleandy!',
  'announcement.trialInfo': 'You have {days} days left in your trial',
  'toast.orderStatusUpdateError': 'Failed to update order status',
  'toast.orderStatusUpdated': 'Order status updated',
  'whatsapp.messageHistory': 'Message History',
  'whatsapp.messages': 'Messages',

  // Receipt Page
  'receipt.title': 'Receipt',
  'receipt.receiptNumber': 'Receipt No',
  'receipt.date': 'Date',
  'receipt.new': 'New Receipt',
  'receipt.reprint': 'Reprint',
  'receipt.searchTitle': 'Search and Reprint Receipt',
  'receipt.customer': 'Customer',
  'receipt.customerName': 'Customer Name',
  'receipt.phone': 'Phone',
  'receipt.items': 'Items',
  'receipt.total': 'Total',
  'receipt.subtotal': 'Subtotal',
  'receipt.tax': 'Tax (KDV)',
  'receipt.discount': 'Discount',
  'receipt.grandTotal': 'Grand Total',
  'receipt.cash': 'Cash',
  'receipt.card': 'Card',
  'receipt.payment': 'Payment',
  'receipt.paymentMethod': 'Payment Method',
  'receipt.partialPayment': 'Partial Payment',
  'receipt.paid': 'Paid',
  'receipt.remaining': 'Remaining',
  'receipt.change': 'Change',
  'receipt.notes': 'Notes',
  'receipt.thankYou': 'Thank you for your business!',
  'receipt.orderReceived': 'Order Received',
  'receipt.deliveryDate': 'Delivery Date',
  'receipt.searchReceipt': 'Search Receipt',
  'receipt.noReceiptFound': 'No receipt found',
  'receipt.searchError': 'Search error',
  'receipt.searchReceiptPlaceholder': 'Enter receipt number...',
  'receipt.thermalPrinter': 'Thermal Printer',
  'receipt.markAsReady': 'Mark Order as Ready',
  'receipt.markAsDelivered': 'Mark Order as Delivered',
  'receipt.whatsappPreview': 'Preview WhatsApp Message',
  'receipt.whatsappPreviewTitle': 'WhatsApp Message Preview',
  'receipt.whatsappPreviewDesc': 'This message will be sent via WhatsApp',
  'receipt.copyTip': 'Tip: You can also select the text and press Ctrl+C to copy',
  'receipt.selectAll': 'Select All',
  'receipt.copyButton': 'Copy',
  'receipt.openWhatsApp': 'Open in WhatsApp',
  'receipt.copySend': 'Send via WhatsApp',
  'receipt.discountedTotal': 'Discounted Total',

  // Z-Report
  'zReport.title': 'Z Report',
  'zReport.singleDay': 'Single Day',
  'zReport.dateRange': 'Date Range',
  'zReport.startDate': 'Start Date',
  'zReport.endDate': 'End Date',
  'zReport.totalOrders': 'Total Orders',
  'zReport.cancelledOrders': 'Cancelled Orders',
  'zReport.totalRevenue': 'Total Revenue',
  'zReport.paymentMethods': 'Payment Methods',
  'zReport.cash': 'Cash',
  'zReport.creditCard': 'Credit Card',
  'zReport.account': 'Account (Caripay)',
  'zReport.free': 'Free of Charge',
  'zReport.paidAtRegister': 'Paid at Registration',
  'zReport.paidAtDelivery': 'Paid at Delivery',
  'zReport.collectionDetails': 'Collection Details',
  'zReport.incoming': 'Incoming',
  'zReport.outgoing': 'Outgoing',
  'zReport.totalRegistered': 'Total Registered',
  'zReport.expenses': 'Expenses',
  'zReport.noExpenses': 'No expenses',
  'zReport.totalExpenses': 'Total Expenses',
  'zReport.cancelledReceipts': 'Cancelled Receipts',
  'zReport.noCancelled': 'No cancelled receipts',
  'zReport.totalCancelled': '{count} cancelled receipts',
  'zReport.reason': 'Reason',
  'zReport.serviceBreakdown': 'Service Breakdown',
  'zReport.loadError': 'Failed to load Z Report',
  'zReport.excelError': 'Excel download error',
  'zReport.excelDownloaded': 'Excel downloaded',
  'zReport.loading': 'Loading...',
  'zReport.todayOrders': "Today's Orders",
  'zReport.registrationAndDelivery': 'Registration + Delivery',
  'zReport.orderPaidAtRegister': 'Order Paid at Register',
  'zReport.orderPaidAtDelivery': 'Order Paid at Delivery',
  'zReport.accountCollections': 'Account Collections',
  'zReport.totalCollection': 'Total Collection',
  'zReport.bankTransfer': 'Bank Transfer',
  'zReport.cashRegister': 'Cash Register',
  'zReport.startingCash': 'Starting Cash',
  'zReport.dailyCashIncome': "Today's Cash Income",
  'zReport.cashToDeliver': 'Cash to Deliver',
  'zReport.cashCalculation': '(Starting Cash + Cash Today - Expenses)',
  'receipt.generalTotal': 'General Total',
  'receipt.footerNote': 'Have a great day!',
  'receipt.homeDelivery': 'Home Delivery',
  'receipt.addressLabel': 'Address',
  'receipt.preview': 'Receipt Preview',
  'receipt.backButton': 'Go Back',
  'receipt.status': 'Status',
  'receipt.whatsappFeature': 'WhatsApp feature is available in Professional and Enterprise plans',
  'receipt.onlyProEnterprise': 'Pro/Enterprise Only',
  'receipt.serviceSummary': 'SERVICE SUMMARY',
  'receipt.plannedDelivery': 'Planned Delivery',
  'receipt.stain': 'Stain',
  'receipt.damage': 'Damage',
  'receipt.taxPercent': 'Tax (20%)',
  'receipt.piece': 'piece',
  'receipt.area': 'Area',
  'receipt.labelPrinting': 'Label {current}/{total} printing...',
  'receipt.andLabel': 'and Label',
  'receipt.whatsappOpening': 'Opening WhatsApp...',
  'receipt.loadError': 'Failed to load data',
  'receipt.products': 'products',
  'receipt.label': 'Label',
  'receipt.connected': 'Connected',
  'receipt.connect': 'Connect',
  'receipt.labelPrinted': 'Label printed!',
  'receipt.printerConnectError': 'Could not connect to printer',
  'receipt.printError': 'Print error',
  'receipt.year': 'Year',
  'receipt.allYears': 'All Years',
  'receipt.cancelled': 'CANCELLED',
  'receipt.cancelledBanner': 'CANCELLED',
  'receipt.cancelledReason': 'Reason',
  'receipt.cancelledDate': 'Cancelled Date',
  'receipt.cancelledBy': 'Cancelled By',
  'receipt.thisReceiptCancelled': 'THIS RECEIPT HAS BEEN CANCELLED',
  'receipt.noCollection': 'No Collection',
  'receipt.invalid': 'INVALID',
  'receipt.searchBy': 'Search by',
  'receipt.searchAll': 'All',
  'receipt.searchName': 'Customer Name',
  'receipt.searchPhone': 'Phone',
  'receipt.phoneNotFound': 'Phone number not found',
  'receipt.sessionNotFound': 'Session not found. Please login again.',
  'receipt.remainingCredits': 'Remaining credits',
  'receipt.creditsFinished': 'You have run out of WhatsApp credits!',
  'receipt.buyCredits': 'Go to Settings → WhatsApp Connection to purchase credits.',
  'receipt.whatsappNotConnected': 'WhatsApp not connected!',
  'receipt.scanQR': 'Go to Settings → WhatsApp Connection to scan QR code.',
  'receipt.goToWhatsAppPage': 'Would you like to go to WhatsApp connection page?',
  'receipt.unknownError': 'Unknown error',
  'receipt.messageFailed': 'Failed to send message',
  'receipt.messageSent': 'Message sent!',
  'receipt.messageSendFailed': 'Message could not be sent',
  'receipt.orderMarkedReady': 'Order marked as ready',
  'receipt.markReadyError': 'Error marking as ready',
  'receipt.orderMarkedDelivered': 'Order marked as delivered',
  'receipt.markDeliveredError': 'Error marking as delivered',
  'receipt.receiptInfo': 'Receipt Info',
  'receipt.customerInfo': 'Customer',
  'receipt.productsInfo': 'Products',
  'receipt.totalPieces': 'Total Pieces',
  'receipt.freeOfCharge': 'Free of Charge',

  // Common
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.unit': 'Unit',
  'common.ok': 'OK',
  'common.save': 'Save',
  'common.search': 'Search',
  'common.loading': 'Loading...',
  'common.searchResults': '(Search results)',
  'common.noData': 'No data',
  'common.actions': 'Actions',
  'common.status': 'Status',
  'common.date': 'Date',
  'common.time': 'Time',
  'common.total': 'Total',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.filter': 'Filter',
  'common.export': 'Export',
  'common.exportExcel': 'Download Excel',
  'common.exportToExcel': 'Export to Excel',
  'common.print': 'Print',
  'common.printDate': 'Print Date',
  'common.pieces': 'pieces',
  'common.back': 'Back',
  'common.clear': 'Clear',
  'common.create': 'Create',
  'common.creating': 'Creating...',
  'common.items': 'Items',
  'common.later': 'Later',
  'common.loadError': 'Could not load',
  'common.none': 'None',
  'common.paid': 'Paid',
  'common.searchError': 'Search error',
  'common.submit': 'Submit',
  'common.year': 'Year',
  'common.allYears': 'All Years',
  'common.cancelled': 'Cancelled',

  // Z-Report
  'zReport.todayRegistrations': 'Today\'s Registrations',
  'zReport.title': 'Z Report',
  'zReport.period': 'Period',
  'zReport.openingBalance': 'Opening Balance',
  'zReport.cashIn': 'Cash In',
  'zReport.cashOut': 'Cash Out',
  'zReport.closingBalance': 'Closing Balance',
  'zReport.totalSales': 'Total Sales',
  'zReport.totalOrders': 'Total Orders',
  'zReport.totalItems': 'Total Items',
  'zReport.totalRevenue': 'Total Revenue',
  'zReport.totalCollected': 'Total Collected',
  'zReport.totalRefunds': 'Total Refunds',
  'zReport.cashPayments': 'Cash Payments',
  'zReport.cardPayments': 'Card Payments',
  'zReport.transferPayments': 'Transfer Payments',
  'zReport.creditPayments': 'Credit Payments',
  'zReport.freeOrders': 'Free Orders',
  'zReport.newCustomers': 'New Customers',
  'zReport.returningCustomers': 'Returning Customers',
  'zReport.byService': 'By Service',
  'zReport.byProduct': 'By Product',
  'zReport.byEmployee': 'By Employee',
  'zReport.printReport': 'Print Report',
  'zReport.generateReport': 'Generate Report',
  'zReport.noData': 'No data for this period',
  'zReport.selectDate': 'Select Date',
  'zReport.daily': 'Daily',
  'zReport.weekly': 'Weekly',
  'zReport.monthly': 'Monthly',
  'zReport.custom': 'Custom',
  'zReport.startDate': 'Start Date',
  'zReport.endDate': 'End Date',

  // Account Statement
  'accountStatement.title': 'Account Statement',
  'accountStatement.customer': 'Customer',
  'accountStatement.balance': 'Balance',
  'accountStatement.totalDebt': 'Total Debt',
  'accountStatement.totalPaid': 'Total Paid',
  'accountStatement.remaining': 'Remaining',
  'accountStatement.statement': 'Statement',
  'accountStatement.receipts': 'Receipts',
  'accountStatement.payments': 'Payments',
  'accountStatement.date': 'Date',
  'accountStatement.description': 'Description',
  'accountStatement.debit': 'Debit',
  'accountStatement.credit': 'Credit',
  'accountStatement.printStatement': 'Print Statement',
  'accountStatement.noData': 'No account statement found',
  'accountStatement.customerReceipts': 'Customer Receipts',
  'accountStatement.noReceipts': 'No receipts found',
  'accountStatement.period': 'Period',
  'accountStatement.allTime': 'All Time',

  // Customer Statement
  'customerStatement.receiptDelivered': 'Delivered',
  'customerStatement.receiptOpen': 'Open',

  // Attributes
  'attributes.title': 'Attributes',
  'attributes.add': 'Add Attribute',
  'attributes.name': 'Attribute Name',
  'attributes.value': 'Value',
  'attributes.color': 'Color',
  'attributes.noAttributes': 'No attributes defined',
  'attributes.saveError': 'Could not save attributes',
  'attributes.saved': 'Attributes saved',
  'attributes.deleteError': 'Could not delete attribute',
  'attributes.deleted': 'Attribute deleted',

  // Damage
  'damage.title': 'Damage Report',
  'damage.add': 'Add Damage',
  'damage.description': 'Description',
  'damage.photo': 'Photo',
  'damage.noPhoto': 'No photo',
  'damage.saveError': 'Could not save damage report',
  'damage.saved': 'Damage report saved',
  'damage.type': 'Damage Type',
  'damage.location': 'Location',
  'damage.severity': 'Severity',
  'damage.hole': 'Hole',
  'damage.tear': 'Tear',
  'damage.burn': 'Burn',
  'damage.fray': 'Fray',
  'damage.button': 'Button Issue',
  'damage.zipper': 'Zipper',
  'damage.stain': 'Stain',
  'damage.color': 'Color Bleed',
  'damage.none': 'None',

  // Delivery List
  'deliveryList.title': 'Delivery List',
  'deliveryList.driver': 'Driver',
  'deliveryList.address': 'Address',
  'deliveryList.phone': 'Phone',
  'deliveryList.status': 'Status',
  'deliveryList.noOrders': 'No orders for delivery',
  'deliveryList.complete': 'Complete',
  'deliveryList.pending': 'Pending',
  'deliveryList.completed': 'Completed',
  'deliveryList.selectDriver': 'Select Driver',

  // Delivery
  'delivery.complete': 'Deliver',
  'delivery.noOrders': 'No orders found',
  'delivery.success': 'Delivery successful',

  // Driver
  'driver.delivery': 'Delivery',
  'driver.searchHint': 'Enter at least 2 characters to search',
  'driver.searchPlaceholder': 'Receipt no, name or phone...',

  // Subscription
  'subscription.title': 'Subscription',
  'subscription.currentPlan': 'Current Plan',
  'subscription.plan': 'Plan',
  'subscription.status': 'Status',
  'subscription.startDate': 'Start Date',
  'subscription.endDate': 'End Date',
  'subscription.monthlyLimit': 'Monthly Limit',
  'subscription.currentUsage': 'Current Usage',
  'subscription.upgrade': 'Upgrade',
  'subscription.renew': 'Renew',
  'subscription.cancel': 'Cancel Subscription',
  'subscription.active': 'Active',
  'subscription.expired': 'Expired',
  'subscription.trial': 'Trial',
  'subscription.starter': 'Starter',
  'subscription.pro': 'Pro',
  'subscription.enterprise': 'Enterprise',
  'subscription.features': 'Features',
  'subscription.perMonth': 'per month',
  'subscription.perYear': 'per year',
  'subscription.monthly': 'Monthly',
  'subscription.yearly': 'Yearly',
  'subscription.selectPlan': 'Select Plan',
  'subscription.payNow': 'Pay Now',
  'subscription.loading': 'Loading subscription...',
  'subscription.noSubscription': 'No active subscription',
  'subscription.trialDaysLeft': 'trial days left',
  'subscription.expiresOn': 'Expires on',
  'subscription.expiredOn': 'Expired on',
  'subscription.renewNow': 'Renew Now',
  'subscription.contactSupport': 'Contact Support',

  // WhatsApp
  'whatsapp.title': 'WhatsApp',
  'whatsapp.connect': 'Connect WhatsApp',
  'whatsapp.disconnect': 'Disconnect',
  'whatsapp.connected': 'Connected',
  'whatsapp.disconnected': 'Disconnected',
  'whatsapp.scanQR': 'Scan QR Code',
  'whatsapp.status': 'Status',
  'whatsapp.credits': 'Credits',
  'whatsapp.buyCredits': 'Buy Credits',
  'whatsapp.creditPackages': 'Credit Packages',
  'whatsapp.messages': 'messages',
  'whatsapp.creditsRemaining': 'credits remaining',
  'whatsapp.noCredits': 'No credits remaining',
  'whatsapp.sendTest': 'Send Test Message',
  'whatsapp.testSent': 'Test message sent',
  'whatsapp.testFailed': 'Test message failed',
  'whatsapp.templates': 'Message Templates',
  'whatsapp.template': 'Template',
  'whatsapp.preview': 'Preview',
  'whatsapp.save': 'Save Template',
  'whatsapp.saved': 'Template saved',
  'whatsapp.orderReady': 'Order Ready',
  'whatsapp.orderDelivered': 'Order Delivered',
  'whatsapp.receiptCreated': 'Receipt Created',

  // Tickets / Support
  'tickets.title': 'Support Tickets',
  'tickets.newTicket': 'New Ticket',
  'tickets.noTickets': 'No tickets found',
  'tickets.noTicketsDesc': 'You have no support tickets yet',
  'tickets.subject': 'Subject',
  'tickets.subjectPlaceholder': 'Support topic...',
  'tickets.description': 'Description',
  'tickets.descriptionPlaceholder': 'Describe your issue in detail...',
  'tickets.fillAllFields': 'Please fill all fields',
  'tickets.created': 'Support ticket created',
  'tickets.createError': 'Could not create support ticket',
  'tickets.loadError': 'Could not load support tickets',
  'tickets.sendError': 'Could not send message',
  'tickets.messages': 'Messages',
  'tickets.conversation': 'Conversation',
  'tickets.typeMessage': 'Type your message...',
  'tickets.closed': 'Closed',
  'tickets.closedMessage': 'This support ticket has been closed.',
  'tickets.admin': 'Admin',
  'tickets.yourName': 'Your Name',
  'tickets.yourNamePlaceholder': 'Enter your name...',
  'tickets.rateExperience': 'Rate Your Experience',
  'tickets.rateDescription': 'Rate your support experience',
  'tickets.rateSupport': 'Support Rating',
  'tickets.selectRating': 'Select Rating',
  'tickets.yourRating': 'Your Rating',
  'tickets.ratingSubmitted': 'Your rating has been saved, thank you!',
  'tickets.ratingError': 'Could not save rating',
  'tickets.translationError': 'Translation error',
  'tickets.status.open': 'Open',
  'tickets.status.closed': 'Closed',
  'tickets.status.investigating': 'Investigating',
  'tickets.status.waitingCustomer': 'Waiting for Customer',
  'tickets.rating.veryBad': 'Very Bad',
  'tickets.rating.bad': 'Bad',
  'tickets.rating.okay': 'Okay',
  'tickets.rating.good': 'Good',
  'tickets.rating.excellent': 'Excellent',

  // Payment (missing)
  'payment.bank': 'Bank Transfer',
  'payment.adjustment': 'Balance adjustment',
  'payment.collect': 'Collect',
  'payment.credit': 'Credit',
  'payment.free': 'Free',
  'payment.paymentCare': 'Account Payment',
  'payment.paymentsSaved': 'Payments saved',
  'payment.saveError': 'Could not save payments',
  'payment.saved': 'Payment saved',
  'payment.split': 'Split Payment',

  // Toast
  'toast.amountExceedsRemaining': 'Amount exceeds remaining balance',
  'toast.cardPaymentError': 'Card payment error',
  'toast.cardPaymentSuccess': 'Card payment successful',
  'toast.carpetAddedToCart': 'Carpet added to cart',
  'toast.carpetsAddedToCart': 'Carpets added to cart',
  'toast.customerExistingSelected': 'Existing customer selected',
  'toast.customerPhoneNotFound': 'Customer phone not found',
  'toast.customerSaveError': 'Could not save customer',
  'toast.customerSaved': 'Customer saved',
  'toast.customerUpdateError': 'Could not update customer',
  'toast.customerUpdated': 'Customer updated',
  'toast.enterValidAmount': 'Enter a valid amount',
  'toast.enterValidArea': 'Enter a valid area',
  'toast.enterValidValue': 'Enter a valid value',
  'toast.logoTooLarge': 'Logo file is too large',
  'toast.logoUploadError': 'Could not upload logo',
  'toast.noEditPermission': 'You do not have edit permission',
  'toast.orderNotFound': 'Order not found',
  'toast.orderSetToReady': 'Order marked as ready',
  'toast.orderUpdateError': 'Could not update order',
  'toast.paymentFailedTryAgain': 'Payment failed, please try again',
  'toast.priceUpdated': 'Price updated',
  'toast.productDetailsUpdated': 'Product details updated',
  'toast.productsLoadError': 'Could not load products',
  'toast.selectAtLeastOneOperation': 'Select at least one operation',
  'toast.selectAtLeastOneService': 'Select at least one service',
  'toast.selectPaymentMethodFirst': 'Select a payment method first',
  'toast.statusUpdateError': 'Could not update status',
  'toast.tailorAddedToCart': 'Tailor service added to cart',
  'toast.uploadingLogo': 'Uploading logo...',
  'toast.whatsappFailed': 'WhatsApp could not be sent',
  'toast.whatsappSent': 'WhatsApp sent',

  // Receipt (missing)
  'receipt.cancelledReason': 'Cancellation Reason',
  'receipt.orderNumber': 'Order No',
  'receipt.printError': 'Print error',
  'receipt.printerConnectError': 'Could not connect to printer',

  // Invoices
  'invoices.downloading': 'Downloading...',

  // Customers (missing)
  'customers.add': 'Add Customer',

  // Settings (missing)
  'settings.africa': 'Africa',
  'settings.americas': 'Americas',
  'settings.asiaPacific': 'Asia Pacific',
  'settings.europe': 'Europe',

  // Signup
  'signup.referral.bonus': 'Referral bonus',
  'signup.referral.title': 'Invitation Code',

  // Product
  'product.damage': 'Damage',
  'product.stain': 'Stain',

  // Order (missing)
  'order.amount': 'Amount',
  'order.processing': 'Processing...',

  // Receipt label dialog
  'receipt.labelConfirmTitle': 'Print Label?',
  'receipt.labelConfirmDesc': 'Receipt created. Send label to the label printer?',
  'receipt.labelYes': 'Yes, Print',
  'receipt.labelNo': 'No',

  // ZReport notes
  'zReport.cashBoxStartNote': 'Opening cash balance',
  'zReport.todayCashNote': 'Cash received today',
  'zReport.branchCollectionsNote': 'Own + other branch collections',
  'zReport.dailyExpensesNote': 'Daily expenses',

  // CustomerCard
  'customerCard.balanceZero': 'Balance is already zero.',
  'customerCard.debtLabel': 'debt will be cleared',
  'customerCard.creditLabel': 'credit will be cleared',
  'customerCard.resetConfirm': 'Balance will be reset ({label}). Confirm?',
  'customerCard.resetSuccess': 'Balance reset successfully',
  'customerCard.resetError': 'Failed to reset balance',
  'customerCard.printTitle': 'Customer Card',
  'customerCard.heading': 'CUSTOMER CARD',
  'customerCard.tel1': 'TEL 1',
  'customerCard.tel2': 'TEL 2',
  'customerCard.address': 'ADDRESS',
  'customerCard.printButton': 'Print Customer Card',
  'customerCard.resetting': 'Resetting...',
  'customerCard.resetBalance': 'Reset Balance',

  // Tailoring (missing)
  'tailoring.loadError': 'Failed to load prices',
  'tailoring.nameRequired': 'Please enter an operation name',
  'tailoring.invalidPrice': 'Please enter a valid price',
  'tailoring.addSuccess': 'New tailoring operation added!',
  'tailoring.saveError': 'Save error',
  'tailoring.deleteConfirm': 'Are you sure you want to delete this operation?',
  'tailoring.deleteSuccess': 'Operation deleted',
  'tailoring.deleteError': 'Delete error',
  'tailoring.saveSuccess': 'Tailoring prices saved!',
  'tailoring.addNewTitle': 'Add New Tailoring Operation',
  'tailoring.operationNameLabel': 'Operation Name',
  'tailoring.priceLabel': 'Price',
  'tailoring.iconLabel': 'Icon (Emoji)',
  'tailoring.operationNamePlaceholder': 'e.g. Collar Sewing',
  'tailoring.savePricesHint': 'Click Save to save prices',
  'tailoring.addCustomHint': 'Use the + button to add a custom operation',

  // ReportsList (missing)
  'reportsList.title': 'Receipt List Report',
  'reportsList.startDate': 'Start Date',
  'reportsList.endDate': 'End Date',
  'reportsList.search': 'Search',
  'reportsList.loading': 'Loading...',
  'reportsList.description': 'All receipts registered or delivered in this date range are listed',
  'reportsList.empty': 'No receipts found in this date range',
  'reportsList.changeDateRange': 'Select a different date range',
  'reportsList.categoryBreakdown': 'Category Breakdown',
  'reportsList.unknown': 'Unknown',
  'reportsList.cancelReason': 'Cancellation Reason:',
  'reportsList.excelDownloaded': 'Excel file downloaded',
  'reportsList.excelError': 'Failed to create Excel file',
  'reportsList.totalReceipt': 'Total Receipts',
  'reportsList.activeReceipt': 'Active Receipts',
  'reportsList.loadError': 'Failed to load receipt list',
  'reportsList.dateError': 'Start date cannot be after end date',

  // Charts
  'charts.revenue': 'Revenue',
  'charts.orders': 'Orders',
  'charts.pieces': 'Piece Count',
  'charts.receipts': 'Receipt Count',
  'charts.loadError': 'Failed to load data',
  'reportsList.created': 'Created',
  'reportsList.delivered': 'Delivered',
  'customerStatement.selectDateRange': 'Select Date Range',
  'customerStatement.thisMonth': 'This Month',
  'customerStatement.lastMonth': 'Last Month',
  'customerStatement.allTime': 'All Time',
  'customerStatement.startDate': 'Start Date',
  'customerStatement.endDate': 'End Date',
  'customerStatement.printPDF': 'Print Statement (PDF)',
  'customerStatement.title': 'ACCOUNT STATEMENT',
  'customerStatement.customerName': 'Customer Name',
  'customerStatement.phone': 'Phone',
  'customerStatement.address': 'Address',
  'customerStatement.openingBalance': 'Opening Balance',
  'customerStatement.closingBalance': 'Closing Balance',
  'customerStatement.description': 'Description',
  'customerStatement.type': 'Type',
  'customerStatement.debit': 'Debit',
  'customerStatement.credit': 'Credit (Collected)',
  'customerStatement.total': 'TOTAL',
  'customerStatement.cancelled': 'CANCELLED',
  'customerStatement.payment': 'Payment',
  'customerStatement.items': 'item(s)',
  'customerStatement.noTransactions': 'No transactions found for the selected period.',
  'customerStatement.statementDate': 'Statement Date',
  'tailoring.subtitle': 'Update tailoring operation prices here',
  'tailoring.addNewDescription': 'Add a custom tailoring operation type',
  'tailoring.operationNamePlaceholder': 'E.g.: Custom Stitch',
  'tailoring.add': 'Add',
  'tailoring.savePrices': 'Save Prices',
  'tailoring.default': 'Default',
  'tailoring.infoTitle': 'Information',
  'tailoring.info1': 'After changing prices, click "Save Prices"',
  'tailoring.info2': 'Use "New Operation" to add custom tailoring operation types',
  'tailoring.info3': 'Delete your custom operations with the trash icon',
  'tailoring.info4': 'These prices are used when the tailoring service is selected in an order',
  'tailoring.info5': 'You can set a separate price for each operation',
  'tailoring.info6': 'Prices are calculated automatically in the customer cart',

  'hardware.title': 'Hardware Store',
  'hardware.subtitle': 'Receipt printers, label printers and Caller ID devices',
  'hardware.cart': 'Cart',
  'hardware.infoTitle': 'Information',
  'hardware.infoText': 'These hardware products are currently only available for purchase in Turkey. They are listed for informational purposes for other countries.',
  'hardware.myCart': 'My Cart',
  'hardware.cartEmpty': 'Cart is empty',
  'hardware.vatSuffix': '+ VAT',
  'hardware.total': 'Total',
  'hardware.checkout': 'Proceed to Payment',
  'hardware.receiptPrinters': 'Receipt Printers',
  'hardware.receiptPrintersSubtitle': '80mm thermal printers with auto-cutter',
  'hardware.compatibilityTitle': 'CleandySoft Compatibility',
  'hardware.receiptCompatText': 'Works with all 80mm thermal printers with auto-cutters.',
  'hardware.labelPrinters': 'Label Printers',
  'hardware.labelPrintersSubtitle': 'Dot matrix printers, 76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'Tested Models',
  'hardware.labelCompatText': 'Tested and optimized for Epson TM-U220 and Bixolon SRP-270. Different brands or models may experience issues.',
  'hardware.callerIdTitle': 'Caller ID Devices',
  'hardware.callerIdSubtitle': 'Customer call identification',
  'hardware.compatibilityNote': 'Compatibility Note',
  'hardware.callerIdCompatText': 'Tested only for CIDShow 2-Line model. Different brands or models may work but are not guaranteed.',
  'hardware.barcodeScanners': 'Barcode Scanners',
  'hardware.barcodeScannerSubtitle': 'USB barcode and QR code scanners',
  'hardware.barcodeCompatText': 'All 2D barcode scanners can work with CleandySoft. Scanners in USB HID mode are automatically supported.',
  'hardware.driverDownloads': 'Driver & Software Downloads',
  'hardware.driverDownloadsText': 'It is recommended to download the appropriate driver before connecting your printer.',
  'hardware.onlyTurkey': 'This product is only available for purchase in Turkey',
  'hardware.addedToCart': 'Added to cart!',
  'hardware.available': 'Available',
  'hardware.info': 'Info',
  'hardware.features': 'Features',
  'hardware.addToCart': 'Add to Cart',
  'hardware.infoOnly': 'For Info Only',
  'expenses.expenseType': 'Expense Type',
  'expenses.allBranches': 'All Branches',
  'expenses.noBranch': 'No Branch',
  'expenses.allTypes': 'All Types',
  'expenses.categoryBy': 'By Category',
  'expenses.records': 'records',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Could not create Excel file',
  'expenses.branchSelect': 'Select branch',
  'expenses.noBranchSelected': '— No branch selected —',
  'expenses.myBranch': 'My Branch',
  'expenses.canOnlyDeleteToday': 'You can only delete expenses you entered today.',

  // Ön eksiz genel anahtarlar (Ürünler/Şablonlar pencerelerinde ham anahtar basılıyordu)
  'cancel': 'Cancel',
  'save': 'Save',
  'update': 'Update',
  'create': 'Create',
  'loading': 'Loading...',
  'back': 'Back',
  'smsSettingsRequired': 'Configure and save the SMS settings above before sending a test SMS',

  // Payment dialog
  'order.selectPaymentMethod': 'Select Payment Method',
  'payment.amountToPay': 'Amount to Pay',
  'payment.remaining': 'Remaining',
  'payment.cash': 'Cash',
  'payment.creditCard': 'Credit Card (POS)',
  'payment.account': 'Account',
  'payment.onDelivery': 'On Delivery',
  'payment.splitPayment': 'Split Payment',
  'payment.mealCard': 'Meal Card',
  'payment.amount': 'Payment Amount',
  'payment.enterAmount': 'Enter Payment Amount',
  'payment.madePayments': 'Payments Made',
  'subscription.referralDesc': 'When a friend you invite signs up and becomes a member, you get 1 extra month! Just sending an invite is not enough.',
};
